var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',_vm._b({attrs:{"tag":"div"}},'transition-group',_vm.transitionProps,false),[(_vm.showGenericIcon)?_c('AvatarColor',{key:"avatarColor"}):(_vm.applicationLogoUrl)?_c('img',{key:"avatarLogo",class:_vm.logoClass,attrs:{"src":_vm.applicationLogoUrl}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }